export const DOMAINS_REQUEST = 'DOMAINS_REQUEST';
export const DOMAINS_SUCCESS = 'DOMAINS_SUCCESS';
export const DOMAINS_ERROR = 'DOMAINS_ERROR';
export const DOMAINS_SELECT = 'DOMAINS_SELECT';
export const DOMAINS_CLEAR = 'DOMAINS_CLEAR';